export default __webpack_public_path__ + "static/media/home-agents.1b8ac1a8.jpg";